module.exports = __webpack_public_path__ + "8b44b014b70c345f87278c2efc75519f.pdf";